import { SystemYear } from '@/const/SystemYear'

/**
 * お知らせ関連メソッド
 */
export default class NoticeUtils {
  /** タイトル最大長 */
  private static TITLE_MAX_LENGTH = 100
  /** 検索条件に表示する過去年数 */
  private static PAST_YEAR_COUNT = 2
  /** 検索条件に表示する未来年数 */
  private static FUTURE_YEAR_COUNT = 1

  /**
   * お知らせ情報の登録・更新前チェックを行う
   *
   * @param title 題名
   * @param messageHtml 本文HTML
   * @returns 有効時：null 無効時：エラーメッセージ
   */
  public static checkNotice(title: string, messageHtml: string): string | null {
    // 題名の必須入力チェック
    if (!title) {
      return '題名がありません'
    }

    // 題名の文字数チェック
    if (title.length > this.TITLE_MAX_LENGTH) {
      return `題名は${this.TITLE_MAX_LENGTH}文字以下で入力してください`
    }

    // 本文の必須入力チェック
    if (!messageHtml) {
      return '本文がありません'
    }

    return null
  }

  /**
   * 検索条件に指定可能な年のリスト
   *
   * @returns 年リスト
   */
  public static yearList(): number[] {
    return SystemYear.yearList(this.PAST_YEAR_COUNT, this.FUTURE_YEAR_COUNT)
  }

  /**
   * 設定可能な開始日の最小値を計算する
   *
   * @param nowDate 現在日時
   * @param currentStartDate 登録されている開始日
   *
   * @returns 開始日の最小値
   */
  public static calcMinDate(nowDate: Date, currentStartDate: Date): Date {
    // 開始日が過去の場合、元の開始日
    if (currentStartDate < nowDate) {
      return currentStartDate
    }

    // 開始日が未来の場合、現在日時
    return nowDate
  }
}
